import { apiCall } from 'src/utils/ApiCall';
import { UserExportRecord } from './getOpenPOExports';

// Temporary interfaces until TypeScript client is updated
export interface GetExportOutput {
  exportRecord: UserExportRecord;
  presignedUrl?: string;
  presignedUrls?: string[]; // Support for multiple URLs
}

export const getOpenPOExport = async (uuid: string): Promise<GetExportOutput> => {
  const response = await apiCall({
    endpoint: `/GetExport/${uuid}`,
    method: 'GET',
  });

  return response as GetExportOutput;
};
